import isEqual from 'react-fast-compare';
import { OnVariablesChanged } from '../DataTableQuery.types';
import { removeEmptyValuesFromObjectDeep } from '../../../../../utils/recordHelpers';

export const areQueryVariablesEqual = (
  queryVariables1: OnVariablesChanged<any, any> | null,
  queryVariables2: OnVariablesChanged<any, any> | null
) => {
  if (!queryVariables1 && !queryVariables2) return true;
  // compare only sort and query
  const qv1 = {
    query: removeEmptyValuesFromObjectDeep(queryVariables1?.query || {}),
    sort: normalizeSort(queryVariables1?.sort)
  };
  const qv2 = {
    query: removeEmptyValuesFromObjectDeep(queryVariables2?.query || {}),
    sort: normalizeSort(queryVariables2?.sort)
  };
  return isEqual(qv1, qv2);
};

function normalizeSort(sort: any) {
  if (!sort) return [];
  return sort;
}
